function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import hexToRgb from './hexToRgb';
import rgbToHex from './rgbToHex';
// based off of https://github.com/noeldelgado/values.js
export default function mix(color1) {
  return function (color2) {
    var weight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
    var _hexToRgb = hexToRgb(color1),
      _hexToRgb2 = _slicedToArray(_hexToRgb, 3),
      red1 = _hexToRgb2[0],
      green1 = _hexToRgb2[1],
      blue1 = _hexToRgb2[2];
    var _hexToRgb3 = hexToRgb(color2),
      _hexToRgb4 = _slicedToArray(_hexToRgb3, 3),
      red2 = _hexToRgb4[0],
      green2 = _hexToRgb4[1],
      blue2 = _hexToRgb4[2];
    var weight1 = weight / 100;
    var weight2 = 1 - weight1;
    var red = Math.round(red1 * weight1 + red2 * weight2);
    var green = Math.round(green1 * weight1 + green2 * weight2);
    var blue = Math.round(blue1 * weight1 + blue2 * weight2);
    return '#' + rgbToHex(red, green, blue);
  };
}